import React from 'react';
import { CONTENT_BASE } from '@amzn/ring-common-style-library/lib/colors';

export const MicIcon: React.FC<{}> = () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' height='100%' width='100%' fill='none'>
        <g id='mic_on (e993)'>
            <path
                id='^ Name above ^'
                fillRule='evenodd'
                clipRule='evenodd'
                d='M18 9C17.724 9 17.5 9.224 17.5 9.5V13C17.5 16.038 15.038 18.5 12 18.5C8.962 18.5 6.5 16.038 6.5 13V9.5C6.5 9.224 6.276 9 6 9C5.724 9 5.5 9.224 5.5 9.5V13C5.506 16.409 8.136 19.203 11.477 19.469L11.5 21H8C7.724 21 7.5 21.224 7.5 21.5C7.5 21.776 7.724 22 8 22H16C16.276 22 16.5 21.776 16.5 21.5C16.5 21.224 16.276 21 16 21H12.5V19.47C15.864 19.203 18.494 16.409 18.5 13.001V9.5C18.5 9.224 18.276 9 18 9ZM12 3C13.381 3 14.5 4.119 14.5 5.5V12.5C14.5 13.881 13.381 15 12 15C10.619 15 9.5 13.881 9.5 12.5V5.5C9.5 4.119 10.619 3 12 3ZM12 2C10.067 2 8.5 3.567 8.5 5.5V12.5C8.5 14.433 10.067 16 12 16C13.933 16 15.5 14.433 15.5 12.5V5.5C15.5 3.567 13.933 2 12 2Z'
                fill={CONTENT_BASE}
            />
        </g>
    </svg>
);
